import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AllRoute from "./routes/AllRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AllRoute />
      </BrowserRouter>
    </div>
  );
}

export default App;
